import Vue from 'vue';
let echarts = require('echarts/lib/echarts');
import { LineChart, BarChart, PieChart, ScatterChart } from 'echarts/charts';
echarts.use([LineChart, BarChart, PieChart, ScatterChart]);
import { GridComponent, LegendComponent, TooltipComponent, DataZoomComponent, MarkLineComponent, TitleComponent } from 'echarts/components';
echarts.use([GridComponent, LegendComponent, TooltipComponent, DataZoomComponent, MarkLineComponent, TitleComponent]);

Vue.prototype.$echarts = echarts;    